import React, { Component } from 'react'

import CopyButton from './copyButton';

class SignatureContainer extends Component {

	getDisclaimer(){
		if (this.props.contactInfo.disclaimer !== "No"){
			const find = this.props.disclaimers.find(dis => dis.id === this.props.contactInfo.disclaimer);
			return find.text;
		}
	}

	getLogo(){
		const {logo} = this.props.contactInfo
		if (logo !== "No"){
			const find = this.props.logos.find(l => l.id === logo);
			return find;
		}
	}

	render(){

		const styles = {
			headingStyle: {
				lineHeight:'1.5',
				color:'#013c65',
				fontSize:'14px',
				fontFamily: 'Arial,Helvetica Neue,Helvetica,sans-serif',
				margin: '0'
			},
			pStyle: {
				lineHeight:'1.25',
				fontSize:'12px',
				fontFamily:'Arial,Helvetica Neue,Helvetica,sans-serif',
				margin:'0'
			},
			disclaimer: {
				lineHeight:'1.25',
				fontSize:'12px',
				fontFamily:'Arial,Helvetica Neue,Helvetica,sans-serif',
				margin:0,
				color: '#666666'
			},
			urlStyle: {
				color: '013c65',
				textDecorationLine: 'Underline'
			},
			height12: {
				height: '12px'
			},
			height24: {
				height: '24px'
			},
			padding15: {
				padding:'0 15px 0 15px'
			},
		}

		const {component, sigId} = this.props;
		const DyanmicSignatureComponent = component;

		return(
			<div className="signature-group" id={"panel-" + sigId}>
				
				<DyanmicSignatureComponent 
					sigId={this.props.sigId}
					contactInfo={this.props.contactInfo}
					disclaimer={this.getDisclaimer()}
					logo={this.getLogo()}
					sharedStyles={styles} />

				<CopyButton 
					sigId={sigId} />
				
			</div>
		)


	}

}

export default SignatureContainer;